import React from "react"
import { ChevronRight } from "react-feather"
import { Tab, TabBody, NavBar, NavBarItem } from "react-weui"

import { EnglishTos, SpanishTos } from "./tos.jsx"
import Page from "../components/FixedBarPage"

import "./TermsOfService.less"


class TermsOfService extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { lang: "eng" }
  }

  render() {
    return (
      <Page
        router={this.props.router}
        title="T&C"
        footerButton={false}
        footerLabel={(
          <div className="restaurantDescriptionButton">
            <span>
              看菜单
            </span>
            <ChevronRight style={{lineHeight: "100%"}} />
          </div>
        )}
        transparentBar
        containerProps={{ className: "tos" }}
      >

        <Tab>
          <NavBar>
            <NavBarItem 
              active={this.state.lang == "eng"} 
              onClick={() => this.setState({ lang: "eng" })}
            >
              🇬🇧 English
            </NavBarItem>
            <NavBarItem
              active={this.state.lang == "esp"} 
              onClick={() => this.setState({ lang: "esp" })}
            >
              🇪🇸 Spanish
            </NavBarItem>
          </NavBar>

          <TabBody>
            {
              this.state.lang == "eng"
                ? <EnglishTos />
                : <SpanishTos />
            }
          </TabBody>
        </Tab>

      </Page>
    )
  }
}


export default TermsOfService



// WEBPACK FOOTER //
// ./src/app/catalogo/pages/TermsOfService.jsx